export default __webpack_public_path__ + "static/telesan_inicio6-b627071a201eb09134cd280d5beee786.jpg";